import axios, { isAxiosError } from "axios";
import { buildAxiosAuthenticationHeaders } from "@src/cloud-connect/api/util/build-axios-authentication-headers";
import { buildRequestedDuration } from "../../vpn-manager/utils/build-requested-ios-duration";
import { vpnManagerUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { SessionVisibilityType } from "@src/types/remote-vnc-session";

export interface postVPNRequestSupportSessionDto {
  namespace: string;
  machineId: string;
  gatewayId: string;
  timeDuration: string;
  timePeriod: string;
  requestMessage: string | null;
  visibility: SessionVisibilityType;
}

export const postVPNRequestSupportSession = async (
  payload: postVPNRequestSupportSessionDto,
) => {
  const url = vpnManagerUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  const requestedDuration = buildRequestedDuration({
    timeDuration: payload?.timeDuration,
    timePeriod: payload?.timePeriod,
  });

  const { namespace, machineId, gatewayId, requestMessage, visibility } =
    payload;
  const requestPayload = {
    namespace,
    machine_id: machineId,
    ...(gatewayId && { gateway_id: gatewayId }),
    requested_duration: requestedDuration,
    message: requestMessage || null,
    visibility: visibility || "private", //default private
  };

  try {
    const response = await axios.post(
      `${url}/api/v2/ns/${namespace}/support-sessions`,
      requestPayload,
      { headers },
    );

    return response?.data;
  } catch (err) {
    if (isAxiosError(err)) {
      console.error("Axios error:", err);
      throw err;
    } else {
      throw new Error(
        "An unexpected error occurred while requesting support session.",
      );
    }
  }
};
